import { message } from "antd";
import { INVENTORY_RECIPE_TYPE, INVENTORY_ADUSTMENT_TYPE_UNIT, INVENTORY_INGREDIENT_UNIT } from "../../constant/constants";
import { getParsedNumber, roundNumber } from "../../utils/Common";

export const readyFoodTypes = [
  { label: 'Recipe', value: 'RECIPE'},
  { label: 'Ready Food', value: 'READY_FOOD'},
  { label: 'Ingredient', value: 'INGREDIENT'},
];

export const getUniLabel = (unitValue) => {
  const unitObj = INVENTORY_INGREDIENT_UNIT.find(item => item.value === unitValue)

  return unitObj === undefined ? '' : unitObj.label;
}

export function getRecipeTypeLabel(recipeTypeValue) {
  if (!Boolean(recipeTypeValue)) return;
  return INVENTORY_RECIPE_TYPE.find((item) => item.value === recipeTypeValue).label;
}

export function getRecipeTypeValue(recipeTypeLabel) {
  if (!Boolean(recipeTypeLabel)) return;
  return INVENTORY_RECIPE_TYPE.find((item) => item.label === recipeTypeLabel).value;
}

export function prepareRecipeList(recipes) {
  if (!Array.isArray(recipes) || recipes.length < 1) return [];
  return [
    ...recipes.map((recipe) => ({
      id: recipe.id,
      recipeType: getRecipeTypeLabel(recipe.recipeType),
      recipeName: recipe.name,
      category: recipe.category?.name || "",
      variantCount: recipe.variantCount,
      status: recipe.status,
      // ingredientCost: recipe.ingredientCost,
      // operationalCost: recipe.operationalCost,
      // totalCost: recipe.totalCost,
      // profit: recipe.profit,
      // sellingPrice: recipe.sellingPrice,
      // extra: {
      //   bgColorClass: getParsedNumber(recipe.profit) < 0 ? "bg-[#FA6060] text-white" : ""
      // }
    })),
  ];
}

export function getOptionNames(options) {
  if (!Array.isArray(options) || options.length < 1) return;
  const modifiedOptions = [...options.map((option) => ({ name: option.name, isSelected: option.isSelected }))];
  return modifiedOptions;
}

function validateIngredientQty(selectedFoodOptions, ingredientItems) {
  const idWiseIng = {};
  ingredientItems.forEach((item) => {
    idWiseIng[item.id] = item.name;
  });

  console.log("----validateIngredientQty---", { selectedFoodOptions });
  let hasAnyError = false;

  for (let i = 0; i < selectedFoodOptions.length; i++) {
    const option = selectedFoodOptions[i];
    const isDefault = ["System Default", "Default"].includes(option.name);

    option.ingredients.forEach((ing) => {
      if (hasAnyError) return;

      if (getParsedNumber(ing.quantity) <= 0) {
        hasAnyError = true;

        message.warning(
          <p className="font-p_regular text-[12px]">
            Please provide quantity greater that zero for ingredient{" "}
            <span className="text-red-500">{idWiseIng[ing.ingredientId]} </span> {isDefault ? "" : `of variant `}{" "}
            <span className="text-red-500">{option.name}</span>.
          </p>
        );
        return false;
      }
    });
  }

  return hasAnyError;
}

export function validateRecipeUpsert(recipeType, name, category, foodOptions, selectedFoodOptions, ingredientItems, readyFoodType, unit) {
  if (recipeType === "") {
    message.warning(
      <p className="font-p_regular text-[12px]">
        Recipe <span className="text-red-500">type</span> can not be empty.
      </p>
    );
    return false;
  }
  if (name === "") {
    message.warning(
      <p className="font-p_regular text-[12px]">
        Recipe <span className="text-red-500">name</span> can not be empty.
      </p>
    );
    return false;
  }
  if (category === "") {
    message.warning(
      <p className="font-p_regular text-[12px]">
        Please select a <span className="text-red-500">category</span> for recipe.
      </p>
    );
    return false;
  }

  
  if (readyFoodType !== "RECIPE" && !unit) {
    message.warning(
      <p className="font-p_regular text-[12px]">
        Please select an <span className="text-red-500">Unit</span>.
      </p>
    );
    return false;
  }

  if (selectedFoodOptions.length === 0) {
    message.warning(
      <p className="font-p_regular text-[12px]">
        Please select <span className="text-red-500">at least one recipe variant</span> for continue.
      </p>
    );
    return false;
  }

  if (foodOptions.length > 0) {
    const checkdOptions = foodOptions.filter((item) => item.isChecked !== false);
    if (checkdOptions.length < 1) {
      message.warning(
        <p className="font-p_regular text-[12px]">
          Please select <span className="text-red-500">at least one recipe variant</span> for continue.
        </p>
      );
      return false;
    }
  }

  if (foodOptions.length > 0) {
    for (let option of selectedFoodOptions) {
      if (!["System Default", "Default"].includes(option.name) && foodOptions.length > 1 && option.name === "") {
        message.warning(
          <p className="font-p_regular text-[12px]">
            Please enter your recipe <span className="text-red-500">variants name</span>!
          </p>
        );
        return false;
      }

      if (option.ingredients.length === 0) {
        message.warning(
          <p className="font-p_regular text-[12px]">
            Please add at least one <span className="text-red-500">ingredient</span> for each recipe variant! Please
            select an <span className="text-red-500">ingredient.</span>
          </p>
        );
        return false;
      }
      
      if ((!Boolean(option.price) || Number(option.price) === 0) && readyFoodType !== 'INGREDIENT') {
        message.warning(
          <p className="font-p_regular text-[12px]">
            Please enter a <span className="text-red-500">selling price.</span>
          </p>
        );
        return false;
      }
    }
  }

  if (validateIngredientQty(selectedFoodOptions, ingredientItems)) {
    return false;
  }

  return true;
}

export function getUpsertFormData(payload) {
  if (Object.keys(payload).length < 1) return;

  const formData = new FormData();
  for (const key in payload) {
    const value = payload[key];

    if (key === "foodImage" && value instanceof File) {
      formData.append(key, value);
    } else if (Array.isArray(value) && key === "addOns") {
      formData.append(key, value.join(","));
    } else if (Array.isArray(value) || (typeof value === "object" && key !== "addOns")) {
      formData.append(key, JSON.stringify(value));
    } else {
      formData.append(key, value);
    }
  }
  return formData;
}

export function getUnitAndCostFromIngredientId(ingredients, ingredientId) {
  if (!Array.isArray(ingredients) || ingredients.length < 1) return;
  const ingredient = ingredients.find((el) => el.id === ingredientId);
  if (!ingredient) return;

  return { unit: ingredient.recipeUnit, unitPrice: ingredient.recipeUnitPrice };
}

export function getIngredientsForUpsert(ingredients) {
  const tempIngredients = ingredients
    .filter((ingredient) => ingredient.ingredientName !== "")
    .map((ingredient) => {
      const { ingredientName, quantity, recipeUnit } = ingredient;

      return {
        ingredientId: ingredientName,
        quantity,
        unit: recipeUnit,
      };
    });
  return tempIngredients;
}

/**
 * @param {object[]} recipeVariants - The user-inputted recipe variants list.
 * @param {boolean} [forEdit=false] - Flag to determine if the function is for editing a recipe or not.
 * @returns {object[]} - The modified recipe variants for the payload.
 */
export function getFinalRecipeVariants(recipeVariants, forEdit = false) {
  let tempSelectedRecipeVariants = [];
  if (forEdit) {
    /**
     * In edit if we add new variant, and that variant new variant must be checked
     */
    tempSelectedRecipeVariants = [
      ...recipeVariants.filter((rev) => !(rev.optionId === "" && rev.isSelected === false)),
    ];
  } else {
    tempSelectedRecipeVariants = recipeVariants.filter((rev) => rev.isSelected === true);
  }

  return [
    ...tempSelectedRecipeVariants.map((variant) => ({
      optionId: variant.optionId,
      status: variant.status,
      name: variant.name,
      isProfitInPercent: variant.isProfitInPercent,
      operationalCost: variant.operationalCost,
      price: variant.sellingPrice,
      ingredients: getIngredientsForUpsert(variant.ingredients),
    })),
  ];
}

export function calculateSellingPrice(profit, profitType, totalCost) {
  if (!profit || !profitType || !totalCost) return;
  let tempSellingPrice = 0;
  if (profitType === "PERCENT") {
    const tempProfitAmount = (Number(profit) / 100) * Number(totalCost);
    tempSellingPrice = Number(totalCost) + tempProfitAmount;
    return tempSellingPrice;
  }
  tempSellingPrice = Number(totalCost) + Number(profit);
  return tempSellingPrice;
}

export function getTotalIngredientCost(ingredients = []) {
  if (ingredients.length < 1) return;
  let totalCost = 0;
  ingredients.map((ingredient) => (totalCost += ingredient.cost));
  return totalCost;
}

export const defaultVariantList = [
  {
    tempVarId: crypto.randomUUID(),
    tempCollapseKey: crypto.randomUUID(),
    optionId: "",
    isSelected: false,
    name: "",
    ingredientCost: 0,
    operationalCost: 0,
    discountAmount: 0,
    discountedPrice: 0,
    totalCost: 0,
    profitAmount: "",
    profitPercent: "",
    profitType: INVENTORY_ADUSTMENT_TYPE_UNIT[0].value,
    sellingPrice: 0,
    ingredients: [
      {
        tempIngredientId: crypto.randomUUID(),
        ingredientId: "",
        ingredientName: "",
        quantity: 1,
        cost: "",
        baseUnit: "",
        recipeUnit: "",
        recipeUnitPrice: "",
        ingredientTotalCost: 0,
      },
    ],
  },
];

const defaultAddOn = {
  addOnId: crypto.randomUUID(),
  name: "",
  price: "",
  isSelected: false,
};

export const defaultAddOns = [defaultAddOn];

export function populateCategoryVariants(categoryVariants) {
  const modifiedVariants = [];
  if (categoryVariants.length < 1) return;
  categoryVariants.forEach((option, idx) => {
    // if (option.name === "Default" || option.name === "System Default") return;
    const tempVariant = {
      tempVarId: crypto.randomUUID(),
      tempCollapseKey: crypto.randomUUID(),
      optionId: option._id,
      status: "Active",
      isSelected: idx === 0,
      name: option.name === "System Default" ? "" : option.name,
      ingredientCost: 0,
      operationalCost: 0,
      discountAmount: 0,
      discountedPrice: 0,
      totalCost: 0,
      profitAmount: "",
      profitPercent: "",
      isProfitInPercent: "No",
      sellingPrice: 0,
      ingredients: [
        {
          tempIngredientId: crypto.randomUUID(),
          ingredientId: "",
          ingredientName: "",
          quantity: 1,
          cost: "",
          baseUnit: "",
          recipeUnit: "",
          recipeUnitPrice: "",
          ingredientTotalCost: 0,
        },
      ],
    };

    modifiedVariants.push(tempVariant);
  });
  return modifiedVariants;
}

export function getFormattedAddOns(addOns = []) {
  if (addOns.length < 1) return;
  const payloadFormat = [];
  addOns.forEach((el) => {
    if (el.isSelected) {
      payloadFormat.push(el.addOnId);
    }
  });

  return payloadFormat;
}

export function prepareFormattedAddOns(addOns = []) {
  // if (addOns.length < 1) return;
  const formatted = addOns.map((el) => ({
    ...el,
    isSelected: true,
  }));
  return formatted;
}

export function getExistingProfits(currentRecipeVariant, totalCost, sellingPrice, profitType, profitRef) {
  let text = "";

  if (profitRef.current !== "") {
    return profitRef.current;
  }

  if (
    profitRef.current === "" &&
    currentRecipeVariant &&
    currentRecipeVariant?.optionId &&
    getParsedNumber(sellingPrice) > 0
  ) {
    let profit = 0;

    if (profitType === "PERCENT") {
      profit = roundNumber(
        ((getParsedNumber(sellingPrice) - getParsedNumber(totalCost)) / getParsedNumber(totalCost)) * 100
      );
      text = `[Ex: ${profit.toFixed(2)} %]`;
    } else {
      profit = roundNumber(getParsedNumber(sellingPrice) - getParsedNumber(totalCost));
      text = `[Ex: ${profit.toFixed(2)} TK]`;
    }
  }
  return text;
}

export const validateReadyFoodStockAdd = (inputs) => {
  if (getParsedNumber(inputs.itemQuantity) <= 0) {
    return "Stock amount is required."
  }

  if (getParsedNumber(inputs.unitPrice) === 0) {
    return "Unit price is required";
  }

  if (inputs.date === '') {
    return "Stock date is required";
  }

  return '';
}
